import { render, staticRenderFns } from "./FeedManagerHeader.vue?vue&type=template&id=35eb02e8&scoped=true&"
import script from "./FeedManagerHeader.vue?vue&type=script&lang=js&"
export * from "./FeedManagerHeader.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagerHeader.vue?vue&type=style&index=0&id=35eb02e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb02e8",
  null
  
)

export default component.exports